import React from 'react';

import {
  CATEGORY_LIST_FILTER_OPTION_MODEL,
  CATEGORY_LIST_PAGINATION_MODEL,
} from '../../../../store/modules/category/models';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import useCategoryListRouter from '../../../../hooks/category/useCategoryListRouter';
import useCategoryDelete from '../../../../hooks/category/useCategoryDelete';
import useToastMsg from '../../../../hooks/common/useToastMsg';
import useCategoryExcelDownload from '../../../../hooks/queries/category/useCategoryExcelDownload';
import useExcelBulkCategoryProductUploadModal from '../../../../hooks/category/useExcelBulkCategoryProductUploadModal';
import useProductCategoryLinkBulkJob from '../../../../hooks/category/useProductCategoryLinkBulkJob';
import useCategoryList from '../../../../hooks/queries/category/useCategoryList';
import categoryToastMsg from '../../../../constants/service/toastMsg/categoryToastMsg';
import CategoryCreateManagementWrap from '../../../../views/category/list/CategoryCreateManagementWrap';

const CategoryCreateManagementContainer = () => {
  const { success } = useToastMsg();

  const {
    data: { categories, filterOption, pagination },
  } = useCategoryList({
    keepPreviousData: true,
    suspense: false,
    initialData: {
      categories: [],
      totalCount: CATEGORY_LIST_PAGINATION_MODEL.totalCnt,
      filterOption: CATEGORY_LIST_FILTER_OPTION_MODEL,
      pagination: CATEGORY_LIST_PAGINATION_MODEL,
    },
    onSuccess: () => success(categoryToastMsg.GET_CATEGORY_LIST_REQUEST_SUCCESS),
  });

  const { routeEvent } = useCategoryListRouter({ filterOption, pagination });

  const { selectedList, onCheckCategoryItem, onDeleteCategoryList } = useCategoryDelete();

  const { refetch } = useCategoryExcelDownload(filterOption, {
    enabled: false,
    onSuccess: (data) => {
      noticeExcelDownloadResult(data.adminEmail);
    },
  });

  // 상품 일괄 업로드는 비동기 잡으로 처리된다 — 진행 상황은 이 훅이 폴링해 카드로 보여준다
  const {
    jobId,
    fileName,
    uploadPercent,
    job,
    isStatusUnavailable,
    isBusy,
    isDownloadingFailedCsv,
    upload,
    downloadFailedCsv,
    dismiss,
  } = useProductCategoryLinkBulkJob();

  const {
    file,
    isUploadModalOpen,
    openUploadModal,
    closeUploadModal,
    onChangeFile,
    initializeFile,
    downloadSample,
    onSubmit,
  } = useExcelBulkCategoryProductUploadModal();

  const categoryListOptionProps = {
    categories,
    filterOption,
    pagination,
    routeEvent,
    selectedList,
    onCheckCategoryItem,
  };

  const excelFeatureProps = {
    refetch,
  };

  const uploadModalProps = {
    file,
    isUploadModalOpen,
    openUploadModal,
    closeUploadModal,
    onChangeFile,
    initializeFile,
    downloadSample,
    onSubmit: () => onSubmit(upload),
  };

  const bulkUploadProps = {
    jobId,
    fileName,
    uploadPercent,
    job,
    isStatusUnavailable,
    isBusy,
    isDownloadingFailedCsv,
    downloadFailedCsv,
    dismiss,
  };

  return (
    <CategoryCreateManagementWrap
      categoryListOption={categoryListOptionProps}
      excelFeature={excelFeatureProps}
      uploadModalFeature={uploadModalProps}
      bulkUploadFeature={bulkUploadProps}
      onDeleteCategoryList={onDeleteCategoryList}
    />
  );
};

export default CategoryCreateManagementContainer;
